const routes = [
  {
    path: '/atencionfacturacion',
    name: 'Atenciones Médicas',
    component: () => import('@/views/forms/AtencionFacturacion.vue'),
    meta: { title: 'Facturación de Atenciones' }
  },
  {
    path: '/factura',
    name: 'Facturas',
    component: () => import('@/views/forms/Factura.vue'),
    meta: { title: 'Gestión de Facturas' }
  },
];

export { routes };
